import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RegistroActivosFijosModalComponent  } from './mostrar-info-activo-fijo-modal.component';

const routes: Routes = [
    { path: '', component: RegistroActivosFijosModalComponent },
  ];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class RegistroActivosFijosRoutingModule { }
